import RunState from 'types/RunState';
import { taskStateColor } from 'utils/taskStateColors';

export default function RunStateLabel({ state }: { state: RunState }) {
  return <div style={{ color: taskStateColor(state) }}>{state}</div>;
}
